import Vue from 'vue'
import Router from 'vue-router'

Vue.use(Router)

/* Layout */
import Layout from '../views/layout/Layout'

/**
 * hidden: true                   if `hidden:true` will not show in the sidebar(default is false)
 * alwaysShow: true               if set true, will always show the root menu, whatever its child routes length
 *                                if not set alwaysShow, only more than one route under the children
 *                                it will becomes nested mode, otherwise not show the root menu
 * redirect: noredirect           if `redirect:noredirect` will no redirct in the breadcrumb
 * name:'router-name'             the name is used by <keep-alive> (must set!!!)
 * meta : {
    title: 'title'               the name show in submenu and breadcrumb (recommend set)
    icon: 'svg-name'             the icon show in the sidebar,
  }
 **/
export const constantRouterMap = [{
		path: '/login',
		component: () => import('@/views/login/index'),
		hidden: true
	},
	{
		path: '/404',
		component: () => import('@/views/word/index'),
		hidden: true
	},
	// {
	// 	path: '',
	// 	component: Layout,
	// 	redirect: '/home',
	// 	hidden: true,
	// 	children: [{
	// 		path: 'home',
	// 		name: 'home',
	// 		component: () => import('@/views/home/index'),
	// 		meta: {
	// 			title: '工作台',
	// 			icon: 'home'
	// 		}
	// 	}]
	// },
	{
		path: '/word',
		component: Layout,
		redirect: '/word/index',
		hidden: true,
		children: [{
			path: 'index',
			name: 'word:index',
			component: () => import('@/views/word/index'),
			meta: {
				title: '工作台',
				icon: 'word'
			}
		}]
	}
]

export const asyncRouterMap = [{
		path: '',
		component: Layout,
		redirect: '/home',
		meta: {
			title: '工作台',
			icon: 'home'
		},
		children: [{
			path: 'home',
			name: 'home',
			component: () => import('@/views/home/index'),
			meta: {
				title: '工作台'
			}
		}]
	}, {
		path: '/site',
		component: Layout,
		redirect: '/site/list',
		name: 'site',
		meta: {
			title: '站点管理',
			icon: 'site'
		},
		alwaysShow: true,
		children: [{
			path: 'list',
			name: 'site:list',
			component: () => import('@/views/site/list'),
			meta: {
				title: '站点管理'
			}
		}]
	},
	{
		path: '/vehicle',
		component: Layout,
		redirect: '/vehicle/list',
		name: 'vehicle',
		meta: {
			title: '车辆管理',
			icon: 'vehicle'
		},
		alwaysShow: true,
		children: [{
			path: 'list',
			name: 'vehicle:list',
			component: () => import('@/views/vehicle/list'),
			meta: {
				title: '车辆管理'
			}
		}]
	},
	{
		path: '/tank',
		component: Layout,
		redirect: '/tank/inventory',
		name: 'tank',
		meta: {
			title: '罐体管理',
			icon: 'tank'
		},
		alwaysShow: true,
		children: [{
				path: 'inventory',
				name: 'tank:inventory',
				component: () => import('@/views/tank/inventory'),
				meta: {
					title: '罐体库存管理'
				}
			}, {
				path: 'specifications',
				name: 'tank:specifications',
				component: () => import('@/views/tank/specifications'),
				meta: {
					title: '规格管理'
				}
			},
			{
				path: 'allTank',
				name: 'tank:all:tank',
				component: () => import('@/views/tank/allTank'),
				meta: {
					title: '全部罐体'
				}
			}
		]
	},
	{
		path: '/airman',
		component: Layout,
		redirect: '/airman/list',
		name: 'airman',
		meta: {
			title: '送气员管理',
			icon: 'airman'
		},
		alwaysShow: true,
		children: [{
			path: 'list',
			name: 'airman:list',
			component: () => import('@/views/airman/list'),
			meta: {
				title: '送气员管理'
			}
		}]
	},
	{
		path: '/operator',
		component: Layout,
		redirect: '/operator/list',
		name: 'operator',
		meta: {
			title: '电话员管理',
			icon: 'operator'
		},
		alwaysShow: true,
		children: [{
			path: 'list',
			name: 'operator:list',
			component: () => import('@/views/operator/list'),
			meta: {
				title: '电话员管理'
			}
		}]
	},
	{
		path: '/orderManage',
		component: Layout,
		redirect: '/orderManage/list',
		name: 'orderManage',
		meta: {
			title: '订单管理',
			icon: 'order'
		},
		alwaysShow: true,
		children: [{
			path: 'create',
			name: 'orderManage:create',
			component: () => import('@/views/orderManage/create'),
			meta: {
				title: '创建订单'
			}
		}, {
			path: 'createContract',
			name: 'orderManage:create:contract',
			component: () => import('@/views/orderManage/createContract'),
			meta: {
				title: '新建退罐合约'
			}
		}, {
			path: 'list',
			name: 'orderManage:list',
			component: () => import('@/views/orderManage/list'),
			meta: {
				title: '订单管理'
			}
		}]
	},
	{
		path: '/contract',
		component: Layout,
		redirect: '/contract/list',
		name: 'contract',
		meta: {
			title: '合约管理',
			icon: 'contract'
		},
		alwaysShow: true,
		children: [{
			path: 'list',
			name: 'contract:list',
			component: () => import('@/views/contract/list'),
			meta: {
				title: '合约管理'
			}
		}]
	},
	{
		path: '/records',
		component: Layout,
		redirect: '/records/list',
		name: 'records',
		meta: {
			title: '检查记录管理',
			icon: 'records'
		},
		alwaysShow: true,
		children: [{
			path: 'list',
			name: 'records:list',
			component: () => import('@/views/records/list'),
			meta: {
				title: '检查汇总'
			}
		}, {
			path: 'detail',
			name: 'records:detail',
			component: () => import('@/views/records/detail'),
			meta: {
				title: '检查明细'
			}
		}]
	},
	{
		path: '/statistics',
		component: Layout,
		redirect: '/statistics/list',
		name: 'statistics',
		meta: {
			title: '统计管理',
			icon: 'statistics'
		},
		alwaysShow: true,
		children: [{
				path: 'list',
				name: 'statistics:list',
				component: () => import('@/views/statistics/list'),
				meta: {
					title: '配送统计'
				}
			},
			{
				path: 'workload',
				name: 'statistics:workload',
				component: () => import('@/views/statistics/workload'),
				meta: {
					title: '工作量统计'
				}
			},
			{
				path: 'account',
				name: 'statistics:account',
				component: () => import('@/views/statistics/account'),
				meta: {
					title: '开户统计'
				}
			},
			{
				path: 'collecting',
				name: 'statistics:collecting',
				component: () => import('@/views/statistics/collecting'),
				meta: {
					title: '收罐统计'
				}
			},
			{
				path: 'debt',
				name: 'statistics:debt',
				component: () => import('@/views/statistics/debt'),
				meta: {
					title: '欠款统计'
				}
			},
			{
				path: 'accrue',
				name: 'statistics:accrue',
				component: () => import('@/views/statistics/accrue'),
				meta: {
					title: '退残累计统计'
				}
			},
			{
				path: 'disabled',
				name: 'statistics:disabled',
				component: () => import('@/views/statistics/disabled'),
				meta: {
					title: '退残统计'
				}
			},
			{
				path: 'calibration',
				name: 'statistics:calibration',
				component: () => import('@/views/statistics/calibration'),
				meta: {
					title: '退残校准'
				}
			},
			{
				path: 'scrap',
				name: 'statistics:scrap',
				component: () => import('@/views/statistics/scrap'),
				meta: {
					title: '原钢瓶报废统计'
				}
			},
			// {
			// 	path: 'volume',
			// 	name: 'statistics:volume',
			// 	component: () => import('@/views/statistics/volume'),
			// 	meta: {
			// 		title: '接单量统计'
			// 	}
			// }
		]
	},
	{
		path: '/withdrawal',
		component: Layout,
		redirect: '/withdrawal/list',
		name: 'withdrawal',
		meta: {
			title: '提现管理',
			icon: 'withdrawal'
		},
		alwaysShow: true,
		children: [{
			path: 'list',
			name: 'withdrawal:list',
			component: () => import('@/views/withdrawal/list'),
			meta: {
				title: '提现管理'
			}
		}]
	},
	{
		path: '/userManage',
		component: Layout,
		redirect: '/userManage/list',
		name: 'userManage',
		meta: {
			title: '用户管理',
			icon: 'userManage'
		},
		alwaysShow: true,
		children: [{
			path: 'list',
			name: 'userManage:list',
			component: () => import('@/views/userManage/list'),
			meta: {
				title: '居民用户'
			}
		}, {
			path: 'industry',
			name: 'userManage:industry',
			component: () => import('@/views/userManage/industry'),
			meta: {
				title: '工业用户'
			}
		}]
	},
	{
		path: '/admin',
		component: Layout,
		redirect: '/admin/carouselList',
		name: 'admin',
		meta: {
			title: '系统管理',
			icon: 'product'
		},
		// alwaysShow: true,
		children: [{
				path: 'regulatoryPlatform',
				name: 'regulatory:platform',
				component: () => import('@/views/system/regulatoryPlatform'),
				meta: {
					title: '监管平台'
				}
			}, {
				path: 'electronicFence',
				name: 'dmin:electronic:fence',
				component: () => import('@/views/system/electronicFence'),
				meta: {
					title: '电子围栏'
				}
			},
			{
				path: 'recovery',
				name: 'admin:recovery',
				component: () => import('@/views/system/recovery'),
				meta: {
					title: '回收站'
				}
			}, {
				path: 'carouselList',
				name: 'admin:carousel:list',
				component: () => import('@/views/system/carouselList'),
				meta: {
					title: '轮播图公告'
				}
			}, {
				path: 'contractTemplate',
				name: 'admin:carousel:template',
				component: () => import('@/views/system/contractTemplate'),
				meta: {
					title: '合约模板'
				}
			}, {
				path: 'scheduleList',
				name: 'admin:schedule:list',
				component: () => import('@/views/schedule/list'),
				meta: {
					title: '定时任务列表'
				}
			},
			{
				path: 'scheduleLog',
				name: 'admin:schedule:log',
				component: () => import('@/views/schedule/log'),
				meta: {
					title: '定时任务日志'
				}
			},
			{
				path: 'fillingData',
				name: 'admin:filling:data',
				component: () => import('@/views/system/fillingData'),
				meta: {
					title: '充装数据'
				}
			},
			{
				path: 'scheduleUpdate',
				name: 'admin:schedule:update',
				component: () => import('@/views/schedule/updateSchedule'),
				meta: {
					title: '更新定时任务'
				},
				hidden: true
			},
			{
				path: 'adimnList',
				name: 'admin:admin',
				component: () => import('@/views/adminUser/list'),
				meta: {
					title: '用户列表'
				}
			},
			{
				path: 'adminUpdate',
				name: 'admin:admin:update',
				component: () => import('@/views/adminUser/update'),
				meta: {
					title: '更新系统用户'
				},
				hidden: true
			},
			{
				path: 'deptList',
				name: 'admin:dept:list',
				component: () => import('@/views/adminUser/dept'),
				meta: {
					title: '部门管理'
				},
				hidden: true
			},
			{
				path: 'adminRole',
				name: 'admin:role',
				component: () => import('@/views/role/list'),
				meta: {
					title: '角色列表'
				}
			},
			{
				path: 'roleAdd',
				name: 'admin:role:add',
				component: () => import('@/views/role/update'),
				meta: {
					title: '更新角色'
				},
				hidden: true
			},
			{
				path: 'adminConfig',
				name: 'admin:config',
				component: () => import('@/views/config/list'),
				meta: {
					title: '配置列表'
				}
			},
			{
				path: 'ratioList',
				name: 'user:ratio',
				component: () => import('@/views/ratio/list'),
				meta: {
					title: '其他'
				}
			},
			{
				path: 'configUpdate',
				name: 'admin:config:add',
				component: () => import('@/views/config/update'),
				meta: {
					title: '更新'
				},
				hidden: true
			},
			{
				path: 'adminLog',
				name: 'admin:log',
				component: () => import('@/views/adminLog/list'),
				meta: {
					title: '系统日志'
				}
			},
			{
				path: 'adminLogDetail',
				name: 'admin:log:detail',
				component: () => import('@/views/adminLog/detail'),
				meta: {
					title: '日志详情'
				},
				hidden: true
			},
			{
				path: 'adminDict',
				name: 'admin:dict',
				component: () => import('@/views/dict/list'),
				meta: {
					title: '字典管理'
				}
			},
			{
				path: 'adminDictData',
				name: 'admin:dict:data',
				component: () => import('@/views/dict/data'),
				meta: {
					title: '字典数据'
				},
				hidden: true
			}
		]
	},
	{
		path: '*',
		redirect: '/404',
		hidden: true
	}
]

export default new Router({
	// mode: 'history', //后端支持可开
	scrollBehavior: () => ({
		y: 0
	}),
	routes: constantRouterMap
})


// WEBPACK FOOTER //
// ./src/router/index.js